const lastEventIdByTopic = new Map();

export const getLastEventIdForTopic = (topic) => {
  if (!topic) return undefined;
  return lastEventIdByTopic.get(topic);
};

export const setLastEventIdForTopic = (topic, eventId) => {
  if (!topic || !eventId) return;

  const current = lastEventIdByTopic.get(topic);
  if (!current || eventId > current) {
    lastEventIdByTopic.set(topic, eventId);
  }
};

export const clearLastEventIdForTopic = (topic) => {
  if (!topic) return;
  lastEventIdByTopic.delete(topic);
};

export const clearAllLastEventIds = () => {
  lastEventIdByTopic.clear();
};
